// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"K1-z","subtitle":"L1-z","wrapper":"M1-z","leftArrow":"N1-z","rightArrow":"O1-z"};